import { useEffect } from 'react'
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';

const RouteChangeTracker = ({ history }) => {
    useEffect(() => {
        const unlisten = history.listen((location) => {
            ReactGA.send({ hitType: 'pageview', page: location.pathname });
        });
        return unlisten;
    }, [history]);

    return null;
};

export default withRouter(RouteChangeTracker);